import React from 'react';
import { Icon } from './Icon.js';
export const IconAlign2RightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.25,17c-.414,0-.75-.336-.75-.75V1.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v14.5c0,.414-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "6", width: "11", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconAlign2RightFill18.js.map